import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";

// Função utilitária para importar imagens dinamicamente
function getProjectImage(title) {
  // Remove caracteres inválidos para nome de arquivo, se necessário
  const fileName = `${title}.png`;
  try {
    // webpack require.context para importar imagens dinamicamente
    return require(`../../../components/img/projects/${fileName}`);
  } catch {
    // fallback caso a imagem não exista
    return "";
  }
}

function SlideHomeProjects() {
  const settings = {
    slidesPerView: 3,
    spaceBetween: 25,
    navigation: true,
    breakpoints: {
      763: {
        spaceBetween: 25,
        slidesPerView: 2,
      },
      762: {
        spaceBetween: 30,
        slidesPerView: 2,
      },
      0: {
        spaceBetween: 20,
        slidesPerView: 1,
      },
    },
  };

  const { t } = useTranslation();
  var projectsItems = t("Home.Projects.List", { returnObjects: true });
  projectsItems = Object.values(projectsItems);

  const items = projectsItems.map((project, index) => (
    <SwiperSlide key={index}>
      <div className="pandin-box">
        <a
          href={project.url}
          target="_blank"
          rel="noopener noreferrer"
          className="project-title"
          style={{ textDecoration: "none", display: "block" }}
        >
          {project.title}
        </a>
        <a
          href={project.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block" }}
        >
          <img
            src={getProjectImage(project.title)}
            alt={project.title}
            className="project-image w-100"
          />
        </a>
        <div className="project-description">
          {project.description}
        </div>
      </div>
    </SwiperSlide>
  ));

  return (
    <Swiper modules={[Navigation]} {...settings}>
      {items}
    </Swiper>
  );
}

export default SlideHomeProjects;
